"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Title_1 = require("../../../parts/Title");
exports.default = Title_1.Title;
//# sourceMappingURL=Title.js.map